import PropTypes from 'prop-types';
import React from 'react';
import { withProps } from 'recompose';
import { Container, Tab } from 'semantic-ui-react'
import { CaseStatusPane, RegistriesPane } from './components';

const Widget = ({ panes }) =>
    <Container>
        <Tab
            panes={panes}
            menu={{ pointing: true }} />
    </Container>

Widget.propTypes = {
    panes: PropTypes.array
}

Widget.defaultProps = {
    panes: []
}

const enhance = withProps({
    panes: [
        {
            menuItem: 'Statusy spraw',
            render: () => <CaseStatusPane />
        },
        {
            menuItem: 'Rejestry',
            render: () => <RegistriesPane />
        }
    ]
})

export default enhance(Widget);


// WEBPACK FOOTER //
// ./src/containers/widget/Widget.js